export default __webpack_public_path__ + "static/media/865D34B0-217F-42DB-BBB5-A2432D3F767F.c6a37b83.jpeg";